/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { mergeQueryKeys, getBaseQueryKey } from "../utils/queryKeyHelpers";
import {
  auditLogRefreshKeys,
  billingReportRefreshKeys,
  checkInComplianceRefreshKeys,
} from "./sharedRefreshKeys";

// Daily Sales is deliberately absent here: its three metrics are covers, net sales and net average
// check, all of them order-derived, so a time entry import cannot change a figure on that report.
// The Daily Logbook stays because it reports labor cost alongside its revenue metrics.
const employeeTimeEntriesBase = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.employee_time_entries),
  getBaseQueryKey(Query_Keys.labor_reports),
  getBaseQueryKey(Query_Keys.labor_report_summary),
  getBaseQueryKey(Query_Keys.daily_logbooks),
  getBaseQueryKey(Query_Keys.daily_logbook_detail),
  auditLogRefreshKeys
);

const reportOrdersBase = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.orders),
  getBaseQueryKey(Query_Keys.guest_orders),
  getBaseQueryKey(Query_Keys.applied_discounts),
  getBaseQueryKey(Query_Keys.order_and_visits),
  getBaseQueryKey(Query_Keys.top_restaurants),
  getBaseQueryKey(Query_Keys.guest_spend_breakdown),
  getBaseQueryKey(Query_Keys.guest_activity_log),
  getBaseQueryKey(Query_Keys.audit_logs),
  getBaseQueryKey(Query_Keys.dashboard_total_sales),
  getBaseQueryKey(Query_Keys.labor_reports),
  getBaseQueryKey(Query_Keys.labor_report_summary),
  getBaseQueryKey(Query_Keys.daily_sales_reports),
  getBaseQueryKey(Query_Keys.daily_logbooks),
  getBaseQueryKey(Query_Keys.daily_logbook_detail),
  checkInComplianceRefreshKeys,
  billingReportRefreshKeys,
  auditLogRefreshKeys
);

// A named-user match sets the order's guest and card, which decide its grandfathering and Industry fee.
const namedUserDiscountsBase = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.named_user_discounts),
  billingReportRefreshKeys
);

export const reportMutationKeyGroups = {
  fetchTimeEntries: employeeTimeEntriesBase,
  fetchOrders: reportOrdersBase,
  connectNamedUser: namedUserDiscountsBase,
};
